import { RootState } from '../store';

export const selectSelectedCategory = (state: RootState) =>
  state.progressiveHeader.selectedCategory;
export const selectshowL1Links = (state: RootState) => state.progressiveHeader.showL1Links;
